import { AppCard, CardProps } from '@/react_app/components/Atoms/index';

interface SectionCardProps extends CardProps {
	sectionTitle?: string;
	sectionSubtitle?: React.ReactNode;
}

const SectionCard = ({ sectionTitle, sectionSubtitle, ...props }: SectionCardProps) => (
	<AppCard
		{...props}
		size="small"
		styles={{
			header: {
				padding: '12px 15px',
			},
			title: {},
		}}
		title={
			<>
				<h2>{sectionTitle}</h2>
				{sectionSubtitle && <div className="m-0 text-xs font-normal text-[#646E87]">{sectionSubtitle}</div>}
			</>
		}
		extra={props.extra}
	>
		<div className="px-4 py-6">{props.children}</div>
	</AppCard>
);

export default SectionCard;
